module.exports = __webpack_public_path__ + "img/1335190636.5ac36819.jpg";